"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = require("react");

// Hook
function useHover(ref) {
  var _useState = (0, _react.useState)(false),
      value = _useState[0],
      setValue = _useState[1];

  var handleMouseOver = function handleMouseOver() {
    return setValue(true);
  };

  var handleMouseOut = function handleMouseOut() {
    return setValue(false);
  };

  (0, _react.useEffect)(function () {
    var node = ref.current;

    if (node) {
      node.addEventListener("mouseover", handleMouseOver);
      node.addEventListener("mouseout", handleMouseOut);
      return function () {
        node.removeEventListener("mouseover", handleMouseOver);
        node.removeEventListener("mouseout", handleMouseOut);
      };
    }
  }, [ref.current] // Recall only if ref changes
  );

  if (typeof window === "object" && !window.matchMedia("screen and (pointer: fine)").matches) {
    return false;
  }

  return value;
}

var _default = useHover;
exports["default"] = _default;